import isEmpty from "lodash/isEmpty";
import type { RuleHandler } from "../types";

const getSatisifesRequirement =
  (requirements: Record<string, number>) =>
  (expectedResults: Record<string, number>): boolean => {
    if (isEmpty(expectedResults)) return false;
    return Object.keys(expectedResults).some((result) => {
      const minimum = requirements[result];
      return expectedResults[result] >= minimum;
    });
  };

const checkMinimumExpectedResults: RuleHandler = (context, requirement) => {
  const requirementAttributes = requirement.userDrivenAttributes;

  if (typeof requirementAttributes.minimumExpectedResults !== "undefined") {
    // convert automation config to match the same shape as the
    // expectedResults from the event: { [resultType]: number }
    const automationRequirementConfig =
      requirementAttributes.minimumExpectedResults.reduce<
        Record<string, number>
      >((acc, expected) => {
        if (!acc[expected.resultType]) {
          acc[expected.resultType] = expected.minimum;
        }

        return acc;
      }, {});

    const satisfiesRequirement = getSatisifesRequirement(
      automationRequirementConfig,
    );

    if (context.selection.isMulti) {
      return context.selection.outcomes.every((outcome) =>
        satisfiesRequirement(outcome.expectedResults),
      );
    }

    return satisfiesRequirement(context.selection.expectedResults);
  }

  return true;
};

export { checkMinimumExpectedResults };
